export var isImage = function (image) {
    if (!image || !image.url) {
        return false;
    }
    return /\.(jpg|jpeg|png)+/.test(image.url);
};
